import axios from '../../../node_modules/axios/index.js'
import { installSessionTimeoutInterceptor } from './session-timeout'

installSessionTimeoutInterceptor(axios)

export default axios
